"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntryHandlerKeyword_1 = require("./EntryHandlerKeyword");
/**
 * Handles @value entries.
 */


var EntryHandlerKeywordValue =
/*#__PURE__*/
function (_EntryHandlerKeyword_) {
  _inherits(EntryHandlerKeywordValue, _EntryHandlerKeyword_);

  function EntryHandlerKeywordValue() {
    _classCallCheck(this, EntryHandlerKeywordValue);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntryHandlerKeywordValue).call(this, '@value'));
  }

  _createClass(EntryHandlerKeywordValue, [{
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(parsingContext, util, key, keys, value, depth) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // If the value is valid, indicate that we are processing a literal.
                // The actual value will be determined at the parent level when the @value is part of an object,
                // because we may want to take into account additional entries such as @language.
                // See {@link Util.valueToTerm}
                // Indicate that we are processing a literal, and that no later predicates should be parsed at this depth.
                parsingContext.literalStack[depth] = true; // Void any buffers that we may have accumulated up until now

                delete parsingContext.unidentifiedValuesBuffer[depth];
                delete parsingContext.unidentifiedGraphsBuffer[depth]; // Indicate that we have not emitted at this depth

                parsingContext.emittedStack[depth] = false;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function handle(_x, _x2, _x3, _x4, _x5, _x6) {
        return _handle.apply(this, arguments);
      }

      return handle;
    }()
  }]);

  return EntryHandlerKeywordValue;
}(EntryHandlerKeyword_1.EntryHandlerKeyword);

exports.EntryHandlerKeywordValue = EntryHandlerKeywordValue;